(function() {

    'use strict';

    angular.module('Services').factory('CropperModalService', CropperModalService);

    function CropperModalService($uibModal){
        return function (opts, props){
            let imageFile = opts && opts.imageFile ? opts.imageFile : null;
            let imageURL = opts && opts.imageUrl ? opts.imageUrl : null;

            const modalProperties = {
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'full-height-modal',
                templateUrl: '/templates/elements/cropper.html',
                controller: 'CropperModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    image: ()=>imageFile,
                    url: ()=>imageURL
                }
            };

            angular.extend(modalProperties, props);

            function getInstance() {
                return $uibModal.open(modalProperties);
            }

            function setImageFile(file) {
                imageFile = file;
            }

            function setImageUrl(url) {
                imageURL = url;
            }

            function dataURItoBlob(dataURI, fileName) {

                let byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0)
                    byteString = atob(dataURI.split(',')[1]);
                else
                    byteString = decodeURIComponent(dataURI.split(',')[1]);

                let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

                let ia = new Uint8Array(byteString.length);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return  blobToFile(new Blob([ia], {type:mimeString}), fileName);

            }
            function blobToFile(theBlob, fileName){
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            }
            angular.extend(this, {
                getInstance,
                setImageFile,
                setImageUrl,
                dataURItoBlob
            });
        };
    }
})();


// WEBPACK FOOTER //
// ./js/services/UX/CropperModalService.js